var _g, _rect, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgVerfied(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 64,
    height: 64,
    viewBox: "0 0 64 64",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_797_7349)"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 64,
    height: 64,
    rx: 32,
    fill: "#F4F8FA"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M21 32L29 40L45 24",
    stroke: "#268035",
    strokeWidth: 4,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }))), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 2,
    y: 2,
    width: 60,
    height: 60,
    rx: 30,
    stroke: "#268035",
    strokeWidth: 4
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_797_7349"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 64,
    height: 64,
    rx: 32,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgVerfied);
export default __webpack_public_path__ + "static/media/Verfied.54e2361cbb0cfb6a9fe9646861d1326e.svg";
export { ForwardRef as ReactComponent };